export enum Message {
    NO_OPTIONS = 'STO.COMMON.NO_RESULTS',
}

export enum Labels {
    RESULTS = 'STO.COMMON.RESULTS',
}

export enum ValidationMsg {
    VALID_VALUE = 'STO.COMMON.VALIDATION.VALID_VALUE',
    REQUIRED = 'STO.COMMON.VALIDATION.REQUIRED',
    VALID_PHONE_NR = 'STO.COMMON.VALIDATION.VALID_PHONE_NR',
    VALID_EMAIL = 'STO.COMMON.VALIDATION.VALID_EMAIL',
    MINIMUM = 'STO.COMMON.VALIDATION.MINIMUM',
    LENGTH_AT_LEAST = 'STO.COMMON.VALIDATION.LENGTH_AT_LEAST',
    LENGTH_AT_MOST = 'STO.COMMON.VALIDATION.LENGTH_AT_MOST',
}

export enum ErrorMsg {
    TRY_AGAIN = 'STO.ERROR.TRY_AGAIN',
    FETCH_QUESTIONS = 'STO.ERROR.FAILED_FETCH_QUESTIONS',
}

export enum Action {
    CHANGE = 'STO.COMMON.ACTION.CHANGE',
    PREVIOUS = 'STO.COMMON.ACTION.PREVIOUS',
    NEXT = 'STO.COMMON.ACTION.NEXT',
}

export enum Common {
    NO_RESULTS = 'STO.COMMON.NO_RESULTS',
}
export const APP_NAME = 'STO.PAGE_TITLES.PROPERTIES.APP_NAME'
export const STICHTING_OPEN = 'STO.PAGE_TITLES.PROPERTIES.STICHTING_OPEN'
export const PAGE_TITLE_SEPARATOR = 'STO.PAGE_TITLES.PROPERTIES.SEPARATOR'

export enum PageTitle {
    SUCCESS = 'STO.PAGE_TITLES.SUCCESS',
    REGISTRATION_CHECK = 'STO.PAGE_TITLES.REGISTRATION_CHECK',
    NOT_FOUND = 'STO.PAGE_TITLES.NOT_FOUND',
    SIGN = 'STO.PAGE_TITLES.SIGN',
    PROGRESS = 'STO.PAGE_TITLES.PROGRESS',
    REVIEW_SUMMARY = 'STO.PAGE_TITLES.REVIEW_SUMMARY',
    REVIEW_FORM = 'STO.PAGE_TITLES.REVIEW_FORM',
    INFORMATION_SUMMARY = 'STO.PAGE_TITLES.INFORMATION_SUMMARY',
    INFORMATION_LOOKUP = 'STO.PAGE_TITLES.INFORMATION_LOOKUP',
    INFORMATION_FORM = 'STO.PAGE_TITLES.INFORMATION_FORM',
}
